module.exports = __webpack_public_path__ + "img/public/SiteIcons/editWrite.svg?41ef6515";